import { useQuery } from 'react-query'

import {
  SystemPreferenceKeys,
  systemPreferenceQueryConfig,
} from '@webapp/platform/iam'

export const useQueryExternalPONumberingSetting = () => {
  const { data, isLoading } = useQuery(
    systemPreferenceQueryConfig.getValue(
      SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE
    )
  )

  return {
    // A never-set preference is the valid "off" state (BHV-004)
    value: data?.value ?? false,
    isLoading,
  }
}
